import React from 'react';
import PropTypes from 'prop-types';

import { withFormikField, getFormikError } from 'utils/formik';
import { Field } from '@ontruck/orc';

const t = {
  label: 'Weight',
  help: 'Kg',
};

const WeightInput = ({ field, form, ...props }) => {
  const { value, name } = field;
  const { setFieldValue } = form;
  return (
    <div>
      <Field
        name={name}
        label={t.label}
        labelType="inner"
        onChange={(e, { value }) => setFieldValue(name, value)}
        width="S"
        asideRightText={t.help}
        value={value || ''}
        invalid={!!getFormikError({ field, form })}
        dataE2E={`shipperOrder_edit__weight_${name}`}
        {...props}
      />
    </div>
  );
};

WeightInput.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
};

export default withFormikField(WeightInput);
